function LoginController($scope, authService) {
    $scope.model = {};
    $scope.val = {};
    $scope.loading = false;

    var self = this;
    /** @type {{returnUrl}} */
    self.query = {};
    if (window.location.search) {
        var s = window.location.search.substring(1);
        _.each(s.split('&'), function(nv) {
            var parts = nv.split('=');
            self.query[parts[0]] = parts.length === 2 ? decodeURIComponent(parts[1]) : true;
        });
        $scope.hasReturn = !!self.query.returnUrl;
        $scope.forgotComplete = self.query.forgot === 'complete';
    }

    $scope.handleUsernameChange = function() {
        delete $scope.val.username;
        delete $scope.val.status;
    };
    $scope.handlePasswordChange = function() {
        delete $scope.val.password;
        delete $scope.val.status;
    };

    $scope.submit = function(e) {
        e.preventDefault();
        $scope.val = {};

        if (!$scope.model.username) {
            $scope.val.username = 'Client code is required.';
        }
        if (!$scope.model.password) {
            $scope.val.password = 'Password is required.';
        }

        // Any errors?
        if (!_.isEmpty($scope.val)) return;
        // Login
        $scope.loading = true;
        authService.login($scope.model.username, $scope.model.password)
            .then(function() {
                if (self.query.returnUrl) {
                    window.location.href = self.query.returnUrl + '?access_token=' + authService.accessToken;
                }
                else {
                    if (authService.claims['admin'] === true) window.location.href = '/admin?access_token=' + authService.accessToken;
                    else window.location.href = '/client?access_token=' + authService.accessToken;
                }
                $scope.loading = false;
            })
            .catch(function(err) {
                console.error(err);
                if (err.status === 401) $scope.val.status = 'Invalid client code or password.';
                else $scope.val.status = 'Unable to login at this time.';
                $scope.loading = false;
            });
    };
}


angular.module('app')
    .component('login', {
        transclude: true,
        controller: ['$scope', 'authService', LoginController],
        templateUrl: '/assets/built/app/components/login/login.html'
    });
